import { z } from 'zod';

export enum ManifestStatus {
  IN_PROGRESS = 'In Progress',
  PENDING_GENERATOR_SIGNATURE = 'Pending Generator Signature',
  PENDING_TRANSPORTER_SIGNATURE = 'Pending Transporter Signature',
  PENDING_DISPOSAL = 'Pending Disposal',
  COMPLETED = 'Completed',
  REJECTED = 'Rejected',
}

export const manifestStatusOptions = [
  ManifestStatus.IN_PROGRESS,
  ManifestStatus.PENDING_GENERATOR_SIGNATURE,
  ManifestStatus.PENDING_TRANSPORTER_SIGNATURE,
  ManifestStatus.PENDING_DISPOSAL,
  ManifestStatus.COMPLETED,
  ManifestStatus.REJECTED,
] as const;

export const ManifestStatusSchema = z.enum(manifestStatusOptions);

export type ManifestStatusOptions = z.infer<typeof ManifestStatusSchema>;
